export default "__VITE_ASSET__CdON8JTs__"